export var ECOMMERCE_FEATURES = {
  DELIVERY_DELAY: 'delivery_delay_notification',
  EXTERNAL_PAGE: 'external_page',
  WHATSAPP_NOTIFICATION: 'whatsapp_notification',
  OCCURRENCE_RADAR: 'occurrence_radar',
  COUPON_AFTER_DELIVERY: 'coupon_after_delivery',
  CSAT_EVALUATION: 'csat_evaluation',
  INVOICE_NOTIFICATION: 'invoice_notification'
};